[
  {
    "id": "TB-M8P-L304-001",
    "module": "Taalbegrip",
    "difficulty": 304,
    "question": "Wat is 'sarcasme'?",
    "options": [
      "Bijtende spot",
      "Milde spot",
      "Humor",
      "Liefde"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "stijl",
    "subSkill": "stijlfiguren",
    "familyId": "TB-SARCASME",
    "explanation": "Sarcasme is harde, bijtende spot, bedoeld om te kwetsen of kritiek te geven.",
    "distractorExplanations": {
      "1": "Ironie.",
      "2": "Te algemeen.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-M8P-L304-002",
    "module": "Taalbegrip",
    "difficulty": 304,
    "question": "Wat betekent 'autonoom'?",
    "options": [
      "Zelfstandig",
      "Afhankelijk",
      "Automatisch",
      "Snel"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-AUTONOOM",
    "explanation": "Autonoom betekent dat je zelf beslist, zelfstandig bent.",
    "distractorExplanations": {
      "1": "Tegenovergestelde.",
      "2": "Lijkt erop, maar is anders.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-M8P-L304-003",
    "module": "Taalbegrip",
    "difficulty": 304,
    "question": "Wat is een 'homoniem'?",
    "options": [
      "Zelfde woord, andere betekenis (bank)",
      "Zelfde betekenis, ander woord",
      "Tegengestelde betekenis",
      "Rijmwoord"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "taalbegrippen",
    "familyId": "TB-HOMONIEM",
    "explanation": "Homoniem: bank (zitten) en bank (geld). Zelfde woord, andere betekenis.",
    "distractorExplanations": {
      "1": "Synoniem.",
      "2": "Antoniem.",
      "3": "Niet waar."
    }
  },
  {
    "id": "TB-M8P-L304-004",
    "module": "Taalbegrip",
    "difficulty": 304,
    "question": "Wat betekent 'improviseren'?",
    "options": [
      "Onvoorbereid iets doen",
      "Goed voorbereiden",
      "Verbeteren",
      "Muziek maken"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-IMPROVISEREN",
    "explanation": "Improviseren is iets doen zonder voorbereiding, op het moment zelf verzinnen.",
    "distractorExplanations": {
      "1": "Tegenovergestelde.",
      "2": "Lijkt erop (improve).",
      "3": "Kan, maar niet de betekenis."
    }
  },
  {
    "id": "TB-M8P-L304-005",
    "module": "Taalbegrip",
    "difficulty": 304,
    "question": "Wat is een 'paradox'?",
    "options": [
      "Schijnbare tegenstelling",
      "Echte tegenstelling",
      "Overdrijving",
      "Vergelijking"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "stijl",
    "subSkill": "stijlfiguren",
    "familyId": "TB-PARADOX",
    "explanation": "Een paradox lijkt een tegenstelling, maar is het bij nader inzien niet.",
    "distractorExplanations": {
      "1": "Antithese.",
      "2": "Hyperbool.",
      "3": "Metafoor."
    }
  }
]